import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FootballMatchHeadToHead from 'modules/Football/components/FootballMatchHeadToHead';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { load, isLoading } from '../reducers/teamHeadToHead';

@standardAsyncConnect([
  {
    dispatch: ({params: {matchId}}) => load(matchId),
    preventResolve: ({state, params: {matchId}}) => isLoading(state, matchId),
    state: (state, props) => ({teamHeadToHead: state.football.teamHeadToHead[props.params.matchId].H2H})
  }
])
@catchLifeCycleErrors
export default class FootballMatchHeadToHeadContainer extends Component {
  static propTypes = {
    matchLabel: PropTypes.string,
    teamHeadToHead: PropTypes.object,
    params: PropTypes.object
  }

  render() {
    return (
      <FootballMatchHeadToHead H2H={this.props.teamHeadToHead} matchLabel={this.props.matchLabel}/>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballMatchHeadToHeadContainer.js